import React, { Component } from 'react';
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';
import Login from './guest/Login';
import NotFound from './modules/NotFound';
import App from './guest/App';
import Dashboard from './auth_pages/Dashboard';
import {firebaseAuth} from './config/firebase';
import DetailPortfolio from './guest/components/DetailPortfolio';

import About from './auth_pages/About';
import Skills from './auth_pages/Skills';
import Experience from './auth_pages/Experience';
import Education from './auth_pages/Education';
import Awards from './auth_pages/Awards';
import Portfolio from './auth_pages/Portfolio';

function PrivateRoute({component: Component, authed, ...rest}) {
  return(
    <Route
      {...rest}
      render={(props) => authed === true ? <Component {...props}/> : <Redirect to={{pathname: '/login', state: {from: props.location}}} />}
    />
  );
}

function PublicRoute({component: Component, authed, ...rest}) {
  return (
    <Route
      {...rest}
      render={(props) => authed === false? <Component {...props} /> : <Redirect to='/dashboard' />}
    />
  );
}

class RouteDeng extends Component {
  constructor(props) {
    super(props);
    this.state = {
      authed: false,
      loading: true
    };
  }

  componentDidMount() {
    this.removeListener = firebaseAuth().onAuthStateChanged((user) => {
      if(user) {
        this.setState({
          authed: true,
          loading: false
        });
      }
      else {
        this.setState({
          authed: false,
          loading: false
        });
      }
    });
  }

  componentWillUnmount() {
    this.removeListener();
  }

  render() {
    
    return (
      this.state.loding === true? <h1>Loading</h1> : (
        <BrowserRouter>
          
            <Switch>
              <Route exact path="/" component={App}/>
              <PublicRoute authed={this.state.authed} path="/login" component={Login}/>
              <Route path="/detail_portfolio/:key" component={DetailPortfolio}/>
              <PrivateRoute authed={this.state.authed} path='/dashboard' component={Dashboard}/>
              <PrivateRoute authed={this.state.authed} path='/_admin/about' component={About}/>
              <PrivateRoute authed={this.state.authed} path='/_admin/skills' component={Skills}/>
              <PrivateRoute authed={this.state.authed} path='/_admin/experience' component={Experience}/>
              <PrivateRoute authed={this.state.authed} path='/_admin/education' component={Education}/>
              <PrivateRoute authed={this.state.authed} path='/_admin/awards' component={Awards}/>
              <PrivateRoute authed={this.state.authed} path='/_admin/portfolio' component={Portfolio}/>
              <Route path="*" component={NotFound}/>
            </Switch>
        </BrowserRouter>
      )

    );
  }
}

export default RouteDeng;



// WEBPACK FOOTER //
// ./src/RouteDeng.js